import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sidebarVisibility: true,
};

export const componentSlice = createSlice({
  name: "component",
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarVisibility = !state.sidebarVisibility;
    },
  },
});

export const { toggleSidebar } = componentSlice.actions;

export default componentSlice.reducer;
